import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row g-3 mb-4" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = {
  key: 0,
  class: "col-md-8 d-flex align-items-end gap-2"
}
const _hoisted_6 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_7 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_8 = {
  key: 2,
  class: "text-muted text-center py-4"
}
const _hoisted_9 = {
  key: 3,
  class: "row g-3"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "fw-semibold" }
const _hoisted_12 = {
  key: 0,
  class: "card-footer"
}
const _hoisted_13 = { class: "d-flex justify-content-end gap-2" }

import { onMounted, reactive, watch } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import Notificacao from "@/components/Notificacao/Index.vue";
import DropdownUsuarios from "@/components/Dropdowns/DropdownUsuarios.vue";

import * as service from "@/services/permissoesService";


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const controle = reactive({
  usuarioId: null as number | null,
  permissoes: [] as service.PermissaoUsuario[],
  notificacao: { exibir: false, mensagem: "", tipo: "success" },
  status: "",
  erro: "",
});

watch(() => controle.usuarioId, (novoId) => {
  if (novoId) carregarPermissoes(novoId);
  else controle.permissoes = [];
});

function carregarPermissoes(usuarioId: number) {
  controle.status = "Carregando...";
  controle.erro = "";
  service.obterPermissoesUsuario(usuarioId)
    .then(r => { controle.permissoes = r; controle.status = ""; })
    .catch(e => { controle.erro = e.message || String(e); controle.status = ""; });
}

function togglePermissao(perm: service.PermissaoUsuario) {
  perm.possui = !perm.possui;
}

function marcarTodas(valor: boolean) {
  controle.permissoes.forEach(p => p.possui = valor);
}

async function salvar() {
  if (!controle.usuarioId) return;

  controle.erro = "";
  controle.status = "Salvando...";

  const ids = controle.permissoes.filter(p => p.possui).map(p => p.permissaoId);

  try {
    await service.salvarPermissoesUsuario({ usuarioId: controle.usuarioId, permissaoIds: ids });
    controle.status = "";
    controle.notificacao = { exibir: true, mensagem: "Permissões salvas com sucesso!", tipo: "success" };
  } catch (e: any) {
    controle.status = "";
    controle.erro = e.message || String(e);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, {
      PageTitle: "Permissões",
      SubTitle: "Gestão de Acesso"
    }),
    _createVNode(Notificacao, {
      exibir: controle.notificacao.exibir,
      mensagem: controle.notificacao.mensagem,
      tipo: (controle.notificacao.tipo as any),
      onOnFechou: _cache[0] || (_cache[0] = ($event: any) => (controle.notificacao.exibir = false))
    }, null, 8, ["exibir", "mensagem", "tipo"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("label", { class: "form-label fw-semibold" }, "Selecione o Usuário", -1)),
            _createVNode(DropdownUsuarios, {
              modelValue: controle.usuarioId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((controle.usuarioId) = $event))
            }, null, 8, ["modelValue"])
          ]),
          (controle.permissoes.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("button", {
                  class: "btn btn-outline-success btn-sm",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (marcarTodas(true)))
                }, [...(_cache[6] || (_cache[6] = [
                  _createElementVNode("i", { class: "flaticon-check" }, null, -1),
                  _createTextVNode(" Marcar todas ", -1)
                ]))]),
                _createElementVNode("button", {
                  class: "btn btn-outline-danger btn-sm",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (marcarTodas(false)))
                }, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("i", { class: "flaticon-close" }, null, -1),
                  _createTextVNode(" Desmarcar todas ", -1)
                ]))])
              ]))
            : _createCommentVNode("", true)
        ]),
        (controle.status)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(controle.status), 1))
          : _createCommentVNode("", true),
        (controle.erro)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(controle.erro), 1))
          : _createCommentVNode("", true),
        (!controle.usuarioId && !controle.status)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Selecione um usuário para gerenciar suas permissões. "))
          : _createCommentVNode("", true),
        (controle.permissoes.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.permissoes, (perm) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: perm.permissaoId,
                  class: "col-md-3 col-sm-4 col-6"
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["border rounded p-3 h-100 d-flex align-items-center gap-2 cursor-pointer permissao-card", { 'bg-success bg-opacity-10 border-success': perm.possui }]),
                    onClick: ($event: any) => (togglePermissao(perm)),
                    style: {"cursor":"pointer"}
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fs-5", perm.possui ? 'flaticon-check text-success' : 'flaticon-close text-secondary'])
                    }, null, 2),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(perm.descricao), 1)
                  ], 10, _hoisted_10)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      (controle.permissoes.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_RouterLink, {
                class: "btn btn-secondary btn-sm",
                to: "/"
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("Fechar", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("button", {
                class: "btn btn-primary btn-sm",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (salvar()))
              }, [...(_cache[9] || (_cache[9] = [
                _createElementVNode("i", { class: "flaticon-check" }, null, -1),
                _createTextVNode(" Salvar Permissões ", -1)
              ]))])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})